module.exports = __webpack_public_path__ + "img/background1.f774280e.jpg";